import { Store as ReduxStore, Dispatch as ReduxDispatch } from "redux"
import { ESourceNames } from "@pag/center/components/quickFilter/quickFilterIconWithSpeaker/types"

export const SET_SONG = "SET_SONG"
export const PLAY_SONG = "PLAY_SONG"
export const SET_CURRENT_BROWSING_CATEGORY_USB = "SET_CURRENT_BROWSING_CATEGORY_USB"
export const SET_CURRENT_BROWSING_CATEGORY_APPLE = "SET_CURRENT_BROWSING_CATEGORY_APPLE"
export const SET_CURRENT_BROWSING_CATEGORY_APPLE_PODCASTS = "SET_CURRENT_BROWSING_CATEGORY_APPLE_PODCASTS"
export const SET_CURRENT_BROWSING_CATEGORY_SIRIUS_XM = "SET_CURRENT_BROWSING_CATEGORY_SIRIUS_XM"
export const DISABLE_ENTRY_ANIMATIONS = "DISABLE_ENTRY_ANIMATIONS"
export const TRIGGER_LIST_SWITCH_ANIMATION = "TRIGGER_LIST_SWITCH_ANIMATION"

export type ReduxInitAction = { type: "@@INIT" }

export interface song {
  title: string
  artist: string
  album: string
  displayed: boolean
  cover: string
  filename: string
  genre: string
}

export interface category {
  name: string
  categoryType: string
  label: string
}

export type setSongAction = {
  type: typeof SET_SONG
  song: song
  source: ESourceNames
  playing: boolean
  listFilter: string
}

export type playSongAction = {
  type: typeof PLAY_SONG
  song: song
  source: ESourceNames
  playing: boolean
}

export type setCurrentBrowsingCategoryUSBAction = {
  type: typeof SET_CURRENT_BROWSING_CATEGORY_USB
  category: category
}

export type setCurrentBrowsingCategory_AppleAction = {
  type: typeof SET_CURRENT_BROWSING_CATEGORY_APPLE
  category: category
}

export type setCurrentBrowsingCategory_ApplePodcastsAction = {
  type: typeof SET_CURRENT_BROWSING_CATEGORY_APPLE_PODCASTS
  category: category
}

export type setCurrentBrowsingCategory_SiriusXMAction = {
  type: typeof SET_CURRENT_BROWSING_CATEGORY_SIRIUS_XM
  category: category
}

export type disableEntryAnimationsAction = {
  type: typeof DISABLE_ENTRY_ANIMATIONS
  disabled: boolean
}

export type trigglerListSwitchAnimationAction = {
  type: typeof TRIGGER_LIST_SWITCH_ANIMATION
  animation: boolean
}

export type audioPlayerState = {
  songs_USB: song[]
  songs_radio: song[]
  songs_online_radio: song[]
  podcasts: song[]
  playing: boolean
  currentBrowsingCategory_USB: category
  currentBrowsingCategory_Apple: category
  currentBrowsingCategory_ApplePodcasts: category
  currentBrowsingCategory_SiriusXM: category
  entryAnimationsDisabled: boolean
  listFilter: string
  listSwitchAnimation: boolean
}

export type Action =
  | ReduxInitAction
  | setSongAction
  | playSongAction
  | setCurrentBrowsingCategoryUSBAction
  | disableEntryAnimationsAction
  | setCurrentBrowsingCategory_AppleAction
  | setCurrentBrowsingCategory_ApplePodcastsAction
  | setCurrentBrowsingCategory_SiriusXMAction
  | trigglerListSwitchAnimationAction

export type Store = ReduxStore<audioPlayerState, Action>

export type Dispatch = ReduxDispatch<Action>

export type SongActionType = setSongAction | playSongAction
